module.exports = __webpack_public_path__ + "static/media/head.2684610c.gltf";